import { categoryRoute } from '~/lib/category-route';
export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return;
  const route = categoryRoute(to.fullPath);
  if (!route) return;
  const { target } = await $fetch('/api/categories/redirect', { query: { path: route.path } });
  if (target) return navigateTo(encodeURI(target) + route.suffix, { replace: true, redirectCode: 301 });
});
